import { render, staticRenderFns } from "./SpecialRoomSummary.vue?vue&type=template&id=0cbdbacc&"
import script from "./SpecialRoomSummary.vue?vue&type=script&lang=js&"
export * from "./SpecialRoomSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports